// GameCardGrid.tsx
import { Box, useTheme } from "@mui/material";
import React from "react";

interface IGameCardGrid {
  children: React.ReactNode;
  rows?: number;
  columns?: number;
}

const GameCardGrid = ({ children, rows = 3, columns = 2 }: IGameCardGrid) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateRows: `repeat(${rows}, auto)`,
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gridGap: theme.spacing(3.5),
        boxSizing: "border-box",
        height: "100%",
      }}
    >
      {children}
    </Box>
  );
};

export default GameCardGrid;
